import { ComponentType, ReactElement, SVGProps } from 'react';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import AmexLogo from '../assets/icons/cards/amex.svg';
import DinersLogo from '../assets/icons/cards/diners.svg';
import DiscoverLogo from '../assets/icons/cards/discover.svg';
import JcbLogo from '../assets/icons/cards/jcb.svg';
import MaestroLogo from '../assets/icons/cards/maestro.svg';
import MastercardLogo from '../assets/icons/cards/mastercard.svg';
import UnionpayLogo from '../assets/icons/cards/unionpay.svg';
import VisaLogo from '../assets/icons/cards/visa.svg';

const LOGOS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  amex: AmexLogo,
  diners: DinersLogo,
  discover: DiscoverLogo,
  jcb: JcbLogo,
  maestro: MaestroLogo,
  mastercard: MastercardLogo,
  unionpay: UnionpayLogo,
  visa: VisaLogo,
};

interface Props {
  brand: string;
  className?: string;
}

export const CardBrandLogo = ({ brand, className }: Props): ReactElement => {
  const Logo = LOGOS[brand.toLowerCase()];

  if (!Logo) {
    return (
      <div
        className={`rounded bg-grey-t-800 flex items-center justify-center text-text-low-priority ${
          className ?? ''
        }`}
      >
        <CreditCardIcon className="size-4" />
      </div>
    );
  }

  return <Logo className={className} />;
};
